var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "example-2 card-video cursor-pointer",
      on: { click: _vm.cardClicked }
    },
    [
      _c(
        "div",
        {
          staticClass: "wrapper",
          style:
            "background: url(" +
            _vm.video.kiss_video.actual_thumbnail_url +
            ") center / cover no-repeat;"
        },
        [
          _c("div", { staticClass: "header" }, [
            _c("ul", { staticClass: "menu-content-left" }, [
              _vm.showLike
                ? _c("li", [
                    _c("i", {
                      staticClass: "mdi mdi-36px mdi-heart shadow-sm",
                      class: { "text-primary": _vm.isVideoFavored },
                      staticStyle: { "text-shadow": "0 0 3px #000" }
                    })
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "menu-content-right" }, [
              _vm.showCompleted
                ? _c("li", [
                    _vm.watchedEntirely
                      ? _c("i", {
                          staticClass:
                            "mdi mdi-36px text-primary shadow-sm mdi-check-decagram",
                          staticStyle: { "text-shadow": "0 0 3px #000" }
                        })
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "data" }, [
            _c("div", { staticClass: "content" }, [
              _c(
                "span",
                { staticClass: "level" },
                [
                  _c("gym-video-level-badge", {
                    attrs: {
                      level: _vm.video.level,
                      label: _vm.video.localized_level,
                      "font-size": "12px"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("h1", { staticClass: "title" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _vm._v(_vm._s(_vm.videoTitle))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hide-area" }, [
                _c("p", { staticClass: "text oswald text-center" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.$t("video.desc", {
                          intensity: _vm.video.intensity,
                          duration: _vm.video.duration / 60
                        })
                      ) +
                      "\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn button btn-dark btn-sm",
                    attrs: { href: "#" }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("video.watch_now")) +
                        "\n                    "
                    )
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }